import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	ViewEncapsulation
} from "@angular/core";
import {BaseButtonComponent} from "./base.button.component";
import {IButton, IButtonDownloadOptions, IButtonTranslateTemplate, IExtendedButton, IExtendedButtonProperties, IThemeColor} from "./button.interface";
import * as _ from "lodash";

/**
 * Custom Button Widget
 */
@Component({
	selector: 'cp-button-widget-custom',
	templateUrl: './button.template.html',
	styleUrls: ['./button.style.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated
})
export class ButtonComponentCustom extends BaseButtonComponent implements OnInit, OnChanges, OnDestroy {
	@Input() id: number;
	@Input() iconClass: string;
	@Input() titleToTranslate: IButtonTranslateTemplate | string;
	@Input() titlePlain: string;
	@Input() tooltipToTranslate: IButtonTranslateTemplate | string;
	@Input() tooltipPlain: string;
	@Input() isSelected: boolean;
	@Input() enforceClick: boolean;
	@Input() isDisabled: boolean;
	@Input() themeColor: IThemeColor;
	@Input() stopPropogation: boolean;
	@Input() downloadOptions:IButtonDownloadOptions;// supported only for icons at this point
    @Input() extendedProperties:IExtendedButtonProperties;
	public button:  IButton|IExtendedButton;

	ngOnInit() {
		this.initButton();
		this.baseOnInit();
	}

	ngOnChanges(changes) {
		this.initButton();
		this.baseOnChanges(changes);
	}

	ngOnDestroy() {
		this.baseOnDestroy();
	}

	public initButton() {
		this.button = {
			id: this.id,
			iconClass: this.iconClass,
			titleToTranslate: _.isString(this.titleToTranslate) ? {template: <string>this.titleToTranslate} :
				<IButtonTranslateTemplate>this.titleToTranslate,
			titlePlain: this.titlePlain,
			tooltipToTranslate: _.isString(this.tooltipToTranslate) ? {template: <string>this.tooltipToTranslate} :
				<IButtonTranslateTemplate>this.tooltipToTranslate,
			tooltipPlain: this.tooltipPlain,
			isSelected: this.isSelected !== undefined ? this.isSelected : false,
			enforceClick: this.enforceClick,
			isDisabled: this.isDisabled !== undefined ? this.isDisabled : false,
			themeColor: this.themeColor,
			stopPropogation: this.stopPropogation,
			downloadOptions:this.downloadOptions,
			... (this.extendedProperties && { extendedProperties: this.extendedProperties })	
		};
	}

}
